import {
  complaintTypes,
  feePaymentMethods,
} from '@/pages/Tools/BuildingInspection/Models';

export const InspectionFormFields = [
  {
    name: 'type',
    label: 'Type',
    type: 'select',
    items: complaintTypes.map((item) => ({ value: item, label: item })),
    grid: {
      sm: 12,
      xs: 12,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'scope',
    label: 'Scope',
    grid: {
      sm: 12,
      xs: 12,
    },
    rules: {
      required: 'This field is required.',
    },
  },

  {
    name: 'assignedTo',
    label: 'Assigned To',
    type: 'select',
    grid: {
      sm: 6,
      xs: 6,
    },
    items: [
      { label: 'Emily Carter', value: 'Emily Carter' },
      { label: 'James Whitman', value: 'James Whitman' },
      { label: 'Sophia Martinez', value: 'Sophia Martinez' },
      { label: 'Alexander Novak', value: 'Alexander Novak' },
      { label: 'Isabella Foster', value: 'Isabella Foster' },
    ],
  },
  {
    name: 'requestDate',
    label: 'Request Date',
    type: 'date',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'name',
    label: 'Name',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'company',
    label: 'Company',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'companyPhone',
    label: 'Company phone',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'cellPhone',
    label: 'Cell Phone',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'email',
    label: 'Email address',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];

export const FeesFormFields = [
  {
    name: 'fee',
    label: 'Fee',
    type: 'number',
    placehoder: '/',
    grid: {
      sm: 6,
      xs: 6,
    },
    rules: {
      required: 'This field is required.',
    },
  },
  {
    name: 'paymentMethod',
    label: 'Payment method',
    type: 'select',
    items: feePaymentMethods.map((method) => ({
      label: method,
      value: method,
    })),
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'checkNumber',
    label: 'Check number',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'receiptNumber',
    label: 'Receipt Number',
    grid: {
      sm: 6,
      xs: 6,
    },
  },
  {
    name: 'feeExplanation',
    label: 'Fee Explanation',
    type: 'textarea',
    rows: 3,
    multiline: true,
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'note',
    label: 'Note',
    type: 'textarea',
    multiline: true,
    rows: 3,
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];
